import moment from 'moment';
import { normalizeDateByBiew } from '../../utils';

/**
 * Get closest header by task date
 * @param {*} headers - table headers
 * @param {*} date - startDate or endDate normalized
 */
const getClosestHeader = (headers, date) => {
  let closest = headers[0];

  for (let i = 0; i < headers.length; i += 1) {
    const currentHeader = headers[i];
    const diff = moment(date).diff(moment(currentHeader.date));
    const absDiff = Math.abs(diff);
    const absClosest = Math.abs(moment(date).diff(moment(closest.date)));

    if (absDiff < absClosest) {
      closest = currentHeader;
    } else if (absDiff === absClosest && absClosest < 0) {
      closest = currentHeader;
    }
  }

  return closest;
};

/**
 * Calculate task card margin to fit in the right tabke column
 * @param {*} margin [left / right]
 * @param {*} date task date
 * @param {*} headers table header columns
 * @param {*} viewBy [WEEK / MONTH]
 */
export const calcMargin = (margin, date, headers, viewBy) => {
  const referenceDate = normalizeDateByBiew(viewBy, date);
  const closest = getClosestHeader(headers, referenceDate);
  const index = headers.findIndex(header => header.id === closest.id);

  if (margin === 'left') {
    return (100 / headers.length) * index;
  }

  if (margin === 'right') {
    return (100 / headers.length) * (headers.length - index - 1);
  }

  return 0;
};

/**
 * Verify if the task end date is less than first column date
 * @param {*} endDate
 * @param {*} headers
 */
const endBeforeFirstHeader = (endDate, headers) => {
  return moment(endDate).diff(headers[0].date) < 0;
};

/**
 * Verify if the task start date is greater than first column date
 * @param {*} startDate
 * @param {*} headers
 */
const startAfterLastHeader = (startDate, headers) => {
  return moment(startDate).diff(headers[headers.length - 1].date) > 0;
};

/**
 * Get card margins and display properties
 * @param {*} task
 * @param {*} headers
 * @param {*} viewBy
 */
export const getParams = (task, headers, viewBy) => {
  const startDate = new Date(task.project.plannedStartDate.slice(0, 16));
  const endDate = new Date(task.project.plannedCompletionDate.slice(0, 16));
  const shouldNotRender =
    startAfterLastHeader(startDate, headers) ||
    endBeforeFirstHeader(endDate, headers);

  if (shouldNotRender) {
    return null;
  }

  const marginLeft = calcMargin('left', startDate, headers, viewBy);
  const marginRight = calcMargin('right', endDate, headers, viewBy);

  const display = marginLeft !== null ? 'block' : 'none';

  return { marginLeft, marginRight, display };
};
